import React, { useEffect } from 'react';

function WaitModal({ show, setShow }) {

  // Auto-close modal after 3 seconds (optional if needed for this page)
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        setShow(false);
      }, 7000); // 3 seconds

      return () => clearTimeout(timer); // Cleanup timer
      
    }
  }, [show, setShow]);

  const modalOverlayStyles = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  };

  const modalContentStyles = {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    textAlign: 'center',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  };

  const buttonStyles = {
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '20px',
  };

  return (
    <>
      {show && (
        <div style={modalOverlayStyles}>
          <div style={modalContentStyles}>
            <h2 style={{padding:'12px'}}>Next Step</h2>
            <p style={{fontSize:'15px'}}>You are being redirected to payment page in 7 seconds. Please make the payment to confirm your booking.</p>
            <button style={buttonStyles} onClick={() => setShow(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default WaitModal;